import {JsonApiService} from '@/modules/claims/services/api'

class LocationApi extends JsonApiService {
  constructor () {
    super('location')
  }
}

export {LocationApi}
